export let colors = {
    background: "#F25869",
    primary1: "#392137", // purple
    primary2: "#F1485B", // darker pink
    primary3: "#F25869", // lighter pink

    grey1: "#333333", // dark grey
    grey2: "#CCCCCC",
    grey3: "#D9D9D9",
    grey4: "#EEEEEE",
    grey5: "#F2F2F2", // light grey

}